import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=2e6ee084&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"
import style0 from "./EventInfo.vue?vue&type=style&index=0&id=2e6ee084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ee084",
  null
  
)

export default component.exports